import React from "react";
import { OMNISCAN_CORPORATE_RED } from "../../../constants/colors";
import Doughnut from "./Doughnut";
import StatBox from "./StatBox";

function formatWhenLabel(ts) {
  if (!ts) return "";

  const d = new Date(ts);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hour = String(d.getHours()).padStart(2, "0");

  return `${day}/${month}/${year} (${hour}:00)`;
}

// --- Main Component --------------------------------------------
export default function UtilisationIndicator({
  title,
  percentage,
  maxValue,
  maxDate,
  minValue,
  minDate,
  darkMode = true   // ⭐ default dark mode
}) {
  // ---- DARK MODE ----------------------------------------------------------
  const darkBorder = "rgba(255,255,255,0.08)";
  const darkTitle = "rgba(255,255,255,0.90)";
  const darkBg = "transparent";

  // ---- LIGHT MODE ---------------------------------------------------------
  const lightBorder = "rgba(0,0,0,0.08)";
  const lightTitle = "rgba(0,0,0,0.75)";
  const lightBg = "transparent"; // stays neutral so it blends on white popups

  // Pick correct palette
  const borderColor = darkMode ? darkBorder : lightBorder;
  const titleColor = darkMode ? darkTitle : lightTitle;
  const containerBg = darkMode ? darkBg : lightBg;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
		gap: 18,
		padding: "18px 20px",
        background: containerBg,
		borderBottom:
		    darkMode
		        ? "1px solid rgba(255,255,255,0.10)"
		        : "1px solid rgba(7,28,49,0.10)",
        marginBottom: 0
      }}
    >
      {/* Doughnut ------------------------------------------------------------ */}
      <div style={{ flex: "0 0 auto" }}>
        <Doughnut value={percentage} darkMode={darkMode} />
      </div>

      {/* Right Side ----------------------------------------------------------- */}
      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 8,
            color: titleColor
          }}
        >
          {title}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 12
          }}
        >
          <StatBox
            label="Max"
            value={maxValue}
            date={formatWhenLabel(maxDate)}
            darkMode={darkMode}
          />

          <StatBox
            label="Min"
            value={minValue}
            date={formatWhenLabel(minDate)}
            darkMode={darkMode}
          />
        </div>
      </div>
    </div>
  );
}
